import ResourceAdmin from "./ResourceAdmin";

const FIELDS = [
  { name: "title", label: "Title", type: "text", list: true },
  { name: "slug", label: "Slug (e.g. genesee-academy)", type: "text", list: true },
  { name: "summary", label: "Short summary", type: "textarea", rows: 2 },
  { name: "description", label: "Full description", type: "textarea", rows: 6 },
  { name: "image_url", label: "Image URL", type: "text" },
  { name: "icon", label: "Icon name (lucide)", type: "text", default: "sparkles" },
  { name: "order", label: "Order", type: "number", default: 0, list: true },
  { name: "is_published", label: "Published", type: "boolean", list: true, default: true },
];

export default function ServicesAdmin() {
  return <ResourceAdmin resource="services" title="Services" fields={FIELDS} />;
}
